export default __webpack_public_path__ + "static/media/25120409.e68464e3.png";